"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "kiwi-messagelist-traffic-group",
    class: `kiwi-messagelist-traffic-group--${_vm.ml.listType}`
  }, [_vm.summary.total === 1 ? _c(_vm.messageComponent, {
    tag: "component",
    attrs: {
      "message": _vm.group.events[0],
      "idx": -1,
      "ml": _vm.ml
    }
  }) : !_vm.expanded ? _c('div', {
    staticClass: "kiwi-messagelist-traffic-group-summary"
  }, [_c('button', {
    staticClass: "kiwi-messagelist-traffic-group-toggle",
    attrs: {
      "type": "button",
      "aria-expanded": false,
      "aria-label": _vm.$t('traffic_expand')
    },
    on: {
      "click": function ($event) {
        _vm.expanded = true;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm.summary.joins.length ? _c('span', {
    staticClass: "kiwi-messagelist-traffic-group-seg"
  }, [_c('span', {
    staticClass: "kiwi-messagelist-traffic-group-sym"
  }, [_vm._v("→")]), _vm._l(_vm.joinsNicks, function (nk, i) {
    return [_c('span', {
      key: i,
      staticClass: "kiwi-nick",
      style: _vm.nickStyles[nk]
    }, [_vm._v(_vm._s(nk))]), i < _vm.joinsNicks.length - 1 ? _c('span', {
      key: `jc${i}`
    }, [_vm._v(", ")]) : _vm._e()];
  }), _c('span', {
    staticClass: "kiwi-messagelist-traffic-group-verb"
  }, [_vm._v(_vm._s(_vm.joinsText))])], 2) : _vm._e(), _vm.summary.departures.length ? _c('span', {
    staticClass: "kiwi-messagelist-traffic-group-seg"
  }, [_c('span', {
    staticClass: "kiwi-messagelist-traffic-group-sym"
  }, [_vm._v("←")]), _vm._l(_vm.departureNicks, function (nk, i) {
    return [_c('span', {
      key: i,
      staticClass: "kiwi-nick",
      style: _vm.nickStyles[nk]
    }, [_vm._v(_vm._s(nk))]), i < _vm.departureNicks.length - 1 ? _c('span', {
      key: `dc${i}`
    }, [_vm._v(", ")]) : _vm._e()];
  }), _c('span', {
    staticClass: "kiwi-messagelist-traffic-group-verb"
  }, [_vm._v(_vm._s(_vm.departuresText))])], 2) : _vm._e(), _vm.summary.nicks.length ? _c('span', {
    staticClass: "kiwi-messagelist-traffic-group-seg"
  }, [_c('span', {
    staticClass: "kiwi-messagelist-traffic-group-sym"
  }, [_vm._v("↔")]), _c('span', {
    staticClass: "kiwi-messagelist-traffic-group-verb"
  }, [_vm._v(_vm._s(_vm.nicksText))])]) : _vm._e(), _vm.summary.modes.length ? _c('span', {
    staticClass: "kiwi-messagelist-traffic-group-seg"
  }, [_c('span', {
    staticClass: "kiwi-messagelist-traffic-group-sym"
  }, [_vm._v("±")]), _c('span', {
    staticClass: "kiwi-messagelist-traffic-group-verb"
  }, [_vm._v(_vm._s(_vm.modesText))])]) : _vm._e(), _vm.ml.bufferSetting('show_timestamps') ? _c('span', {
    staticClass: "kiwi-messagelist-time",
    attrs: {
      "title": _vm.ml.formatTimeFull(_vm.firstTime)
    }
  }, [_vm._v(_vm._s(_vm.ml.formatTime(_vm.firstTime)))]) : _vm._e()]) : _c('div', {
    staticClass: "kiwi-messagelist-traffic-group-detail"
  }, [_c('button', {
    staticClass: "kiwi-messagelist-traffic-group-toggle",
    attrs: {
      "type": "button",
      "aria-expanded": true,
      "aria-label": _vm.$t('traffic_collapse')
    },
    on: {
      "click": function ($event) {
        _vm.expanded = false;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-minus",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._l(_vm.group.events, function (ev, i) {
    return _c(_vm.messageComponent, {
      key: i,
      tag: "component",
      attrs: {
        "message": ev,
        "idx": -1,
        "ml": _vm.ml
      }
    });
  })], 2)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];